.kdx-basic-hero {
	position: relative;	
	width: 100%;
	background: $basicHeroBG;  
	color: $basicHeroText;
	padding: 30px 0;

	h1, h2, h3, h4, h5, h6,
	.h1, .h2, .h3, .h4, .h5, .h6 {
		color: $basicHeroText;
	}
	.row {
		justify-content: space-between;
		align-items: center;
	}
	.bg-image {
		background-repeat: no-repeat;
		background-size: 100%;
		background-position: top left;
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
	}
	h1 { margin: 0 0 8px 0; }
	.subheading {
		@include text-size(24);
		@include line-height(33);
		margin: 0;
	}
	
	// team bio hero
	&.team-bio-hero {
		background: $teamBioHeroBG;
		color: $teamBioHeroText;
		display: flex;
		padding: 48px 0;
				
		.contact-box {
			background: $teamBioHeroContactBox;
			box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
			padding: 24px;
			margin-right: 85px;
			@include line-height(30);

			p { padding-bottom: 5px; }
			a {
				color: $teamBioHeroContactText;
				text-decoration: none;				

				&:hover, &:focus {
					text-decoration: underline;
				}
			}
		}
	}
}






@include media-breakpoint-down(lg) {
	.kdx-basic-hero {
		
		&.team-bio-hero {
			padding: 40px 0;

			.contact-box {
				text-align: center;
				margin-top: 16px;
				@include text-size(12);
				@include line-height(24);
			}
		}
	}
}



@include media-breakpoint-down(md) {
	.kdx-basic-hero {
		text-align: center;
		padding: 24px 0;
		background: $basicHeroBGMobile;
		
		.cta { margin-top: 16px; }
		&.team-bio-hero {

			.contact-box {
				text-align: left;
			}
		}
	}
}




@include media-breakpoint-down(sm) {
	.kdx-basic-hero {
		
		.cta { 
			
			.btn { min-width: 80%; }
		}
	}
}